<template>
  <div v-if="skill" class="level-test-page">
    <button type="button" class="back-link" @click="navigateToView('Profile')">
      <span class="material-icons" aria-hidden="true">chevron_left</span>{{ $t($route.query.setup === '1' ? 'learnerProfile.returnToSetup' : 'levelTest.backToProfile') }}
    </button>
    <ListeningTest v-if="skill === 'listening'" />
    <SpeakingTest v-else />
  </div>
</template>

<script>
import { useViews } from '@/composables/views'
import { useAuth } from '@/composables/auth'
import { useLearnerProfile } from '@/composables/useLearnerProfile'
import { localizedRouteName } from '@/router'
import ListeningTest from './ListeningTest.vue'
import SpeakingTest from './SpeakingTest.vue'

export default {
  name: 'LevelTestPage',
  components: { ListeningTest, SpeakingTest },
  setup() {
    const { handleViewChange } = useViews()
    const { user } = useAuth()
    const { adoptGuestOnboarding } = useLearnerProfile()
    return { navigateToView: handleViewChange, user, adoptGuestOnboarding }
  },
  computed: {
    skill() {
      const value = this.$route.query.skill
      return ['listening', 'speaking'].includes(value) ? value : null
    }
  },
  watch: {
    user(next, previous) {
      if (next && !previous && this.$route.query.setup === '1') this.adoptGuestOnboarding()
    },
    skill: {
      immediate: true,
      handler(value) {
        if (!value && this.$route.meta.page === 'LevelTest') {
          this.$router.replace({ name: localizedRouteName('Profile', this.$route.meta.locale) })
        }
      }
    }
  }
}
</script>

<style scoped>
.level-test-page {
  width: 100%;
  max-width: 720px;
  margin: 0 auto;
  padding-bottom: var(--space-16);
}

.back-link {
  display: inline-flex;
  align-items: center;
  min-height: 44px;
  margin: 0 0 var(--space-4) calc(var(--space-2) * -1);
  padding: var(--space-1) var(--space-2);
  border: none;
  border-radius: var(--radius-sm);
  background: transparent;
  color: var(--ink-secondary);
  font: inherit;
  font-size: var(--font-size-sm);
  cursor: pointer;
}

.back-link:hover {
  background: var(--surface-subtle);
  color: var(--ink-primary);
}

.back-link .material-icons {
  font-size: 20px;
}

.back-link:focus-visible {
  outline: 2px solid var(--signal-active-strong);
  outline-offset: 2px;
}
</style>
